import { RegisterDetailsPage } from "components/register/details/RegisterDetailsPage";
import { Home } from "./pages/home/Home";
import CreateInternalRequestPage from "./pages/requests/CreateRequestsForm";
import ConfirmationPage from "pages/confirmation/ConfirmationPage";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/requests/create/:type',
    element: <CreateInternalRequestPage />
  },
  {
    path: '/register-details/:registerId',
    element: <RegisterDetailsPage />
  },
  {
    path: '/confirmation',
    element: <ConfirmationPage />
  }
];

export default AppRoutes;
